import { getTierIntersectionForFeature } from 'marketplace-ui-apps-core/installability/utils/featureCompatibilities';
import { CompatibilityModal } from 'marketplace-ui-details/compatibility/CompatibilityModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const FeatureCompatibilityModal = ({
  appContext,
  features,
  onClose,
  installability,
  trackInteraction
}) => {
  const featuresWithTierCompatibility = features.map(feature => {
    var _installability$featu;
    const featureCompatibility = installability === null || installability === void 0 || (_installability$featu = installability.featureCompatibilities) === null || _installability$featu === void 0 ? void 0 : _installability$featu.find(compat => compat.featureId === feature.id);
    const tierIntersectionForFeature = getTierIntersectionForFeature(feature, featureCompatibility);
    return {
      text: feature.title,
      tiers: tierIntersectionForFeature
    };
  });
  return /*#__PURE__*/_jsx(CompatibilityModal, {
    appContext: appContext,
    featuresWithTierCompatibility: featuresWithTierCompatibility,
    onClose: onClose,
    productType: "APP",
    portalTiers: (installability === null || installability === void 0 ? void 0 : installability.portalTiers) || [],
    trackInteraction: trackInteraction
  });
};